import styles from "./fadeInTop.module.scss";

interface UIProps {
  children: React.ReactNode;
  shouldRender: boolean;
  isVisible: boolean | undefined;
  duration: number;
  delay: number;
}

const UI = ({
  children,
  shouldRender,
  isVisible,
  duration,
  delay,
}: UIProps) => {
  return (
    <div
      className={styles.container}
      style={{
        animation: `${isVisible ? "fadeInTop" : "fadeOutTop"} ${
          duration + delay
        }s`,
        opacity: isVisible ? 1 : 0,
      }}
    >
      {shouldRender && children}
    </div>
  );
};

export default UI;
